import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=65e06ba6&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e06ba6')) {
      api.createRecord('65e06ba6', component.options)
    } else {
      api.reload('65e06ba6', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=65e06ba6&", function () {
      api.rerender('65e06ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21G3p08TE0kFc/JS/comp/offers.vue"
export default component.exports